import React from 'react';
import { Row, Typography } from 'antd';
import './styles.less';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';

const { Text, Title } = Typography;

export type FieldsetProps = {
  description?: string;
  extraContent?: React.ReactNode;
  comcode: string;
  maxWidth?:string;
  display?:string;
};

const Fieldset: React.FC<FieldsetProps> = ({ comcode,maxWidth,display, ...otherProps }) => {
  const { children, description, extraContent } = otherProps;

  const { isHidden, label, style } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  return (
    <fieldset className={'fieldset'} style={{maxWidth:maxWidth,display:display}}>
      <div className={'labelWrapper'}>
        <label>
          <Title level={4} style={style}>
            {label}
          </Title>
        </label>
        <Text type="secondary" className={'description'}>
          {description}
        </Text>
        {extraContent}
      </div>

      <Row gutter={16} style={{ flexGrow: 1 }}>
        {children}
      </Row>
    </fieldset>
  );
};

export default Fieldset;
